import { usePlayground } from "../../playground-store";

import { usePlaygroundChannel } from "./usePlaygroundChannel";

import { Message } from "@/components/Messaging/types";
import { WEBSOCKET_MESSAGE_NAME } from "@/constants";

const useTemplateAppendListener = () => {
  const playground = usePlayground();

  const handleTemplateAppend = (payload: Message) => {
    const response = JSON.parse(payload.data);
    const {
      individual_run_request_id,
    }: {
      individual_run_request_id: number;
    } = response;
    const template: string = response?.payload?.template;

    const operation =
      playground.operationStore.getAssociatedOperationByRequestId(individual_run_request_id);

    if (!operation?.output_instance_id) {
      const clonedPlayground = playground.clone(operation);

      const output = playground.addOutput(clonedPlayground);

      playground.operationStore.assignOutputId(operation!.id, output.instanceId);
    }

    playground.appendToTemplate(template);
  };

  usePlaygroundChannel(WEBSOCKET_MESSAGE_NAME.APPEND_TO_TEMPLATE, handleTemplateAppend);
};

export default useTemplateAppendListener;
